import React from "react";

// Recreated Foco Vision eye mark as inline SVG for crisp scaling
const Logo = ({ variant = "dark", showText = true, className = "" }) => {
  const stroke = variant === "light" ? "#e8eaed" : "#2f3a45";
  const accent = "#94a7b8";
  const textColor = variant === "light" ? "#ffffff" : "#2f3a45";
  const subColor = variant === "light" ? "#94a7b8" : "#94a7b8";

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <svg width="46" height="38" viewBox="0 0 120 96" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M8 46 C 30 14, 90 14, 112 46" stroke={stroke} strokeWidth="5" strokeLinecap="round" fill="none" />
        <path d="M14 52 C 34 78, 86 78, 106 52" stroke={accent} strokeWidth="5" strokeLinecap="round" fill="none" opacity="0.9" />
        <path d="M74 48 a20 20 0 1 1 -20 -20" stroke={stroke} strokeWidth="5" strokeLinecap="round" fill="none" />
        <circle cx="54" cy="48" r="6" fill={accent} />
      </svg>
      {showText && (
        <div className="leading-none">
          <div className="font-display font-semibold tracking-[0.18em] text-lg" style={{ color: textColor }}>
            FOCO VISION
          </div>
          <div className="font-display tracking-[0.28em] text-[9px] mt-1" style={{ color: subColor }}>
            CENTRO OFTALMOLÓGICO
          </div>
        </div>
      )}
    </div>
  );
};

export default Logo;
